import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { fetchReclamation, initDetailsReclamation } from 'store/reclamation/detailsActions';

import { useParams, Navigate } from "react-router-dom";

import ReclamationPage from './ReclamationPage';

const ReclamationPageContainer = ({ fetchReclamation, initDetailsReclamation, isLoading, error, reclamation }) => {

    let params = useParams();

    React.useEffect(() => {
        fetchReclamation(params.id);
    }, [fetchReclamation, params.id]);

    React.useEffect(() => {
        return () => {
            initDetailsReclamation();
        };
    }, [initDetailsReclamation]);


    if (error && error.response && error.response.status === 404) {

        console.log("404");

        return (<Navigate to="/404"/>);
    }

    return (<ReclamationPage isLoading={isLoading} reclamation={reclamation} />);
};



ReclamationPageContainer.propTypes = {
    isLoading: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    reclamation: state.reclamation.details.item,
    isLoading: state.reclamation.details.isLoading,
    error: state.reclamation.details.error
});


const mapDispatchToProps = {
    fetchReclamation,
    initDetailsReclamation,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReclamationPageContainer);